var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulesConfiguration1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n        stroke: #c9c9c9;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.04,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.03,9.1h0c-.18-.14-.41-.21-.65-.19-.24.03-.46.14-.6.32-.14.18-.21.4-.18.63.03.23.14.43.32.58l4.02,4.26-3.92,4.26c-.34.33-.35.87-.03,1.21.16.18.4.28.65.28.23,0,.45-.09.61-.24l4.98-5.55-5.19-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.43,15.74c1.67-.45,2.65-1.7,2.65-3.4s-1.09-3.53-4.14-3.53h-3.86v11.8h1.8v-4.7h1.58l2.74,4.7h2.15l-2.92-4.87Zm.8-3.4c0,1.33-.81,2.06-2.29,2.06h-2.06v-4.05h2.06c1.52,0,2.29.67,2.29,1.99Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesConfiguration1);
export default __webpack_public_path__ + "static/media/rules-configuration-1.445fb87d9cb921f10c28adef32620c8b.svg";
export { ForwardRef as ReactComponent };